import apiClient from "../apiClient";

export default {
    // Schedules
    getSchedules: () => apiClient.get("workSchedules"),
    getSchedule: id => apiClient.get(`workSchedules/${id}`),
    previewSchedule: (id, params) => apiClient.get(`workSchedules/${id}/preview?${params}`),
    addSchedule: payload => apiClient.post("workSchedules", payload),
    editSchedule: (id, payload) => apiClient.put(`workSchedules/${id}`, payload),
    makeDefault: id => apiClient.put(`workSchedules/${id}/default`),
    deleteSchedule: id => apiClient.delete(`workSchedules/${id}`),

    // Assignments
    getAssignments: params => apiClient.get(`workScheduleAssignments?${params}`),
    getAssignment: id => apiClient.get(`workScheduleAssignments/${id}`),
    addAssignment: payload => apiClient.post("workScheduleAssignments", payload),
    editAssignment: (id, payload) => apiClient.put(`workScheduleAssignments/${id}`, payload),
    deleteAssignment: id => apiClient.delete(`workScheduleAssignments/${id}`),
    getEffective: params => apiClient.get(`workScheduleAssignments/effective?${params}`),

    // Special periods (Ramadan)
    getPeriods: () => apiClient.get("workPeriods"),
    getPeriod: id => apiClient.get(`workPeriods/${id}`),
    addPeriod: payload => apiClient.post("workPeriods", payload),
    editPeriod: (id, payload) => apiClient.put(`workPeriods/${id}`, payload),
    deletePeriod: id => apiClient.delete(`workPeriods/${id}`),
    getPeriodReview: id => apiClient.get(`workPeriods/${id}/review`),
    getReminders: () => apiClient.get("workPeriods/reminders"),
};
